import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardActionArea,
  Chip,
} from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";
import SeoHead from "../components/SeoHead";
import blogPosts from "../data/blogPosts";

export default function BlogPage() {
  const navigate = useNavigate();

  const categories = Array.from(new Set(blogPosts.map((p) => p.category)));

  return (
    <Box id="blog-page" sx={{ maxWidth: 900, mx: "auto", mt: 4 }}>
      <SeoHead
        title="Blog"
        description="Read articles about music brackets, song ranking strategies, music discovery tips, and the culture of music competition. Guides, insights, and more."
        canonical="/blog"
      />

      <Typography variant="h4" textAlign="center" gutterBottom>
        <ArticleIcon
          sx={{ fontSize: 36, mr: 1, verticalAlign: "middle", color: "#3498db" }}
        />
        Music Brackets Blog
      </Typography>
      <Typography
        variant="body1"
        textAlign="center"
        color="text.secondary"
        sx={{ mb: 2, maxWidth: 650, mx: "auto" }}
      >
        Guides, tips, and insights about music brackets, song rankings, music
        discovery, and the culture of comparing music. Whether you are new to
        brackets or a seasoned player, there is something here for you.
      </Typography>

      <Box sx={{ display: "flex", gap: 1, justifyContent: "center", mb: 4, flexWrap: "wrap" }}>
        {categories.map((cat) => (
          <Chip
            key={cat}
            label={cat}
            size="small"
            sx={{
              backgroundColor: "rgba(52,152,219,0.1)",
              color: "text.secondary",
            }}
          />
        ))}
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
          gap: 3,
          mb: 4,
        }}
      >
        {blogPosts.map((post) => (
          <Card
            key={post.slug}
            sx={{
              backgroundColor: "rgba(255,255,255,0.02)",
              border: "1px solid rgba(255,255,255,0.06)",
              "&:hover": {
                borderColor: "rgba(52,152,219,0.3)",
              },
            }}
          >
            <CardActionArea onClick={() => navigate(`/blog/${post.slug}`)}>
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <Chip
                    label={post.category}
                    size="small"
                    sx={{
                      backgroundColor: "rgba(52,152,219,0.12)",
                      color: "#3498db",
                      fontSize: "0.7rem",
                    }}
                  />
                  <Typography variant="caption" color="text.secondary">
                    {post.readTime}
                  </Typography>
                </Box>
                <Typography variant="h6" sx={{ fontSize: "1rem", mb: 1 }}>
                  {post.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {post.description}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ mt: 1, display: "block" }}
                >
                  {new Date(post.date).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  );
}
